import { validation } from 'site-modules/shared/components/form-validation/validation';

export const CHART_SETTINGS = {
  MARGIN: {
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  RECT: {
    MOBILE: {
      POS: 65,
      TEXT_POS: 74,
      TEXT_SIZE: 12,
    },
    DESKTOP: {
      POS: 65,
      TEXT_POS: 78,
      TEXT_SIZE: 14,
    },
  },
};
export const CORA_LOGO = '/img/car-buying/cora/cora-logo.png';
export const BEST_DEAL_CTA = 'See who has the best deal';
export const CTA_NEXT = 'Get Your Custom Price Quote Comparison';
export const CROUDSOURCED_DEALS_CHECKOUT_STEP = 'crowdsourcedDealsCheckout';
export const CROUDSOURCED_DEALS_THANK_YOU_STEP = 'crowdsourcedDealsThankYou';

export const FORM_FIELDS = {
  firstName: 'first_name',
  lastName: 'last_name',
  zipCode: 'zip',
  email: 'email',
};

export const VALIDATORS = {
  [FORM_FIELDS.firstName]: {
    test: validation.validateName,
    errorText: 'Please correct your name. Special characters cannot be included.',
  },
  [FORM_FIELDS.lastName]: {
    test: validation.validateName,
    errorText: 'Please correct your name. Special characters cannot be included.',
  },
  [FORM_FIELDS.zipCode]: {
    test: validation.validateZip,
    errorText: 'Please enter a valid ZIP code.',
  },
  [FORM_FIELDS.email]: {
    test: validation.validateEmail,
    errorText: 'Please enter a valid email.',
  },
};

export const SUBMIT_URL = 'https://3ax68jyyk9.execute-api.us-west-2.amazonaws.com/prod/submit_request';
export const API_KEY = 'QEML0AHf4j4I6mGdr9PtJ9Al1u3MjNwZ4Zw8iQNV';

export const CREATIVE_ID = 'quote-bot-promo-main-well';
export const FORM_MODAL_CREATIVE_ID = 'quote-bot-signup-form-modal';
export const CROWDSOURCED_DEALS_EVENTS = {
  QUOTE_BOT_START: 'csd.quote_bot_start',
  WIDGET_VIEW: 'csd.widget_view',
  SUBMIT_FORM: 'csd.submit_form',
  INPUT_VALIDATION: 'csd.input_validation',
};
